import { datadogRum } from "@datadog/browser-rum";

export const ANALYTICS_EVENTS = {
  HOME_INSIGHTS: {
    NAVIGATION: "homeInsights:paginationNavigation",
    VIEW_CONVERSATIONS: "homeInsights:viewConversations",
    VIEW_INSIGHTS: "homeInsights:viewInsights",
    SEND_EMAIL: "homeInsights:sendEmail",
    INSIGHTS_EXPOSED: "homeInsights:insightsExposed",
  },
  SCREENING_POLICY: {
    RAW_DATA_VIEW: "screeningPolicies:rawDataViewClicked",
    POLICY_ROW_MENU_ITEM: "screeningPolicies:policyRowMenuItem",
    CREATE_POLICY_MENU_ITEM: "screeningPolicies:createPolicyMenuItem",
    SUBMIT_POLICY: "screeningPolicies:submitPolicy",
    DIALOG_CREATE_COPY: "screeningPolicies:dialogCreateCopy",
    DIALOG_EDIT_ANYWAY: "screeningPolicies:dialogEditAnyway",
    DIALOG_DELETE: "screeningPolicies:dialogDelete",
    DIALOG_DUPLICATE: "screeningPolicies:duplicatePolicy",
  },
  INTEGRATION_EXPRESSION_VIEW: {
    VIEW_PAGE: "integrationExpression:viewPage",
    TEST_EXPRESSION: "integrationExpression:testExpression",
    VERSION_CHANGED: "integrationExpression:versionChanged",
  },
  TEST_CONNECTION: {
    CLICKED: "testConnection:clicked",
    SUCCEEDED: "testConnection:succeeded",
    FAILED: "testConnection:failed",
  },
  FETCH_SAMPLE: {
    CLICKED: "fetchSample:clicked",
    SUCCEEDED: "fetchSample:succeeded",
    FAILED: "fetchSample:failed",
  },
  AUTOMATION_POTENTIAL_BANNER: {
    SHOWN: "automationPotentialBanner:shown",
    EXPLORE_CLICKED: "automationPotentialBanner:exploreClicked",
    DISMISSED: "automationPotentialBanner:dismissed",
  },
  GENERAL: {
    CREATE_ASSISTANT: "createAssistant",
    PREVIEW_USAGE: "previewUsage",
    PUBLISH_CHANGES: "publishChanges",
    KNOWLEDGE_EXPLORER_USAGE: "knowledgeExplorerUsage",
    ADD_RESPONSE: "addResponse",
    SAVE_ADD_RESPONSE: "saveAddResponse",
    PAGE_NAV: "pageNav",
    TOGGLE_WIDGET: "ToggleWidget",
    OPEN_MENU: "openMenu",
    ROW_SUBMITTED: "rowSubmitted",
    BULK_ACTION_MODE_SELECTED: "bulkActionModeSelected",
    PREVIEW_SHARED: "previewShared",
    CALL_ME_CLICKED: "callMeClicked"
  },
};

// Account/assistant/user context rides on every RUM event via the global
// context set in src/datadog/index.js; payload fields still take precedence.
export const trackEvent = (actionName, payload = {}) => {
  datadogRum.addAction(actionName, payload);
};

export const notifyCreateAssistant = ({ newAssistantId, assistantType, isDuplicate }) => {
  trackEvent(ANALYTICS_EVENTS.GENERAL.CREATE_ASSISTANT, {
    assistantType,
    isNewAssistant: true,
    assistantId: newAssistantId, // Overrides the global assistantId if different
    isDuplicate,
  });
};
